<template>
  <div>
    <p>
      The EMBO Workshop: Visualising Biological Data (VIZBI 2019) marked the 10<sup>th</sup>
      meeting on this topic. It was held March 13&ndash;15 at the
      <a href="https://www.embl.de/training/cco/atc/">EMBL Advanced Training Centre</a>,
      Heidelberg, Germany.
    </p>
    <HeroImage hero-image="Hero.jpg" flyer-hi-res="Poster.pdf" credit="EMBL 2019" />
    <p>
      VIZBI 2019 featured talks from 21 world-leading researchers who showcased visualizations
      transforming how life scientists view data, and driving key advances in molecular biology,
      systems biology, biomedical science, and ecology.
    </p>
    <p>
      The conference brought together a diverse community, including bioinformaticians, data
      scientists, computer scientists, and experimentalists, as well as medical illustrators,
      graphic designers, and graphic artists.
    </p>
    <p>
      All participants had the opportunity to present a
      <router-link to="Posters">poster and lightning talk</router-link> describing their work.
    </p>
    <p>
      <del>
        Prior to the meeting, a
        <a href="https://datavismasterclass.org" target="_blank" rel="nofollow">
          Data Visualization Masterclass</a
        >
        covering general principles, methods, and tools for gaining insight from complex data was
        planned.</del
      >
      Unfortunately the Masterclass was cancelled that year.
    </p>
    <p>
      As with previous meetings, VIZBI 2019 was an exciting event that helped raise the standard
      of data visualization in the life sciences. Highlights from the meeting are available on the
      VIZBI
      <router-link to="/blog">blog</router-link>,
      <router-link to="/Posters/2019">posters</router-link>,
      <router-link to="/photos/2019">photos</router-link>, and
      <router-link to="/videos">videos</router-link> pages.
    </p>
    <p>
      To receive updates about VIZBI, you can join the
      <router-link to="/Mail">VIZBI mailing list</router-link>.
    </p>
    <h3>Key Dates</h3>
    <table>
      <colgroup>
        <col span="1" style="width: 40%" />
        <col span="1" style="width: 60%" />
      </colgroup>
      <tbody>
        <tr>
          <td><b>Dec 14, 2018</b> <span>(23:00 CET)</span>:</td>
          <td>Deadline for EMBL CPP Fellowship applications</td>
        </tr>
        <tr>
          <td>
            <del><b>Feb 1, 2019</b> <span>(23:00 CET)</span>:</del>
          </td>
          <td><del>Deadline for conference registration</del></td>
        </tr>
        <tr>
          <td><b>Feb 15, 2019</b> <span>(23:00 CET)</span>:</td>
          <td>Extended deadline for conference registration</td>
        </tr>
        <tr>
          <td><b>Mar 4, 2019</b> <span>(23:00 PST)</span>:</td>
          <td>Extended deadline for <router-link to="Posters">poster &amp; Art &amp; Biology</router-link> upload</td>
        </tr>
        <tr>
          <td><b>Mar 13&ndash;15</b>:</td>
          <td><router-link to="Program">VIZBI conference</router-link></td>
        </tr>
      </tbody>
    </table>
    <p>
      <a href="http://www.embo.org/funding-awards/courses-workshops/workshops">
        <img
          src="/2019/img/emworkshop_lores.png" height="116" alt="EMBO Workshops"
          title="EMBO Workshops">
      </a>
      <a href="https://www.embo.org/">
        <img src="/2019/img/embo_lores.png" height="116" alt="EMBO" title="EMBO">
      </a>
      <a href="https://www.embl.de/training/cco/atc/">
        <img src="/2019/img/embl_lores.png" height="116" alt="EMBL" title="EMBL">
      </a>
      <a href="http://www.iscb.org/" rel="nofollow">
        <img src="/2019/img/ISCB.png" alt="ISCB" title="ISCB">
      </a>
    </p>
  </div>
</template>

<script setup>
import HeroImage from "@/components/HeroImage.vue";
</script>

<style scoped>
b {
  font-weight: 600;
}
span {
  font-weight: 200;
}
</style>
